import { Button } from '@/components/ui/button';
import { FilterLibraryStateEnum, useGeneratorFilterStore } from '@/state/generator-filter-store';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const WelcomeUse: React.FC = () => {
  const { setCurrentState } = useGeneratorFilterStore();
  const navigate = useNavigate();

  return (
    <div className="bg-[#1C1C1C] flex items-center justify-center p-6 h-full">
      <div className="w-[281px] space-y-6">
        <h1 className="text-[32px] leading-[90%] tracking-[-1.6px] font-medium text-[#efeff0]">Introducing StyleFilters™</h1>
        <p
          className=" text-[14px] leading-[110%] tracking-[-0.7px]"
          style={{
            color: 'rgba(255, 255, 255, 0.60)',
          }}
        >
          StyleFilters™ is where creativity meets ethics, setting a new collaboration standard in the generative music space. Jen's Filters
          let creators apply unique musical signatures to their tracks.
        </p>
        <div className="flex items-center gap-4 pt-2">
          <Button
            className="!bg-jen-orange hover:bg-jen-orange !p-2 h-[28px] leading-[100%] text-white !rounded-[4px] px-6 py-2.5 text-[0.8rem] hover:opacity-90"
            onClick={() => {
              navigate('/marketplace');
            }}
          >
            <span className=" relative top-[1px]">
              Shop StyleFilters<sup className="top-[-6px] text-[6px]">TM</sup>
            </span>
          </Button>
          <div
            className="flex gap-1 text-jenmusic-interactive text-[12px] tracking-[-0.24px] items-center cursor-pointer hover:opacity-90"
            onClick={() => window.open('https://jenmusic.ai/stylefilters ', '_blank')}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
              <rect x="0.413086" width="12" height="12" rx="6" fill="#FF5B27" />
              <path d="M4.91333 4.5H7.91333V7.5" stroke="#191A1B" stroke-width="0.918803" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.91333 4.5L4.91333 7.5" stroke="#191A1B" stroke-width="0.918803" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Learn More
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeUse;
